import React from "react";
import {useDispatch} from "react-redux";

import ActionModal from "./ActionModal";

import {ReactComponent as EditIcon} from "./../../assets/edit.svg";
import {ReactComponent as CloseIcon} from "./../../assets/close.svg";
import {deleteAction} from "../../redux/proposal";

function ActionRow({index, action}) {
    const dispatch = useDispatch();
    const [editingOpened, setEditingOpened] = React.useState(false);

    return (
        <div
            style={{
                height: 70,
                maxHeight: 70,
                boxSizing: "border-box",
                borderRadius: 8,
                border: "1px solid var(--grey3)",
                marginBottom: 10,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 20
            }}
        >
            {editingOpened && <ActionModal isOpen={editingOpened} setIsOpen={setEditingOpened} editIndex={index} />}
            <span>{action.signature}</span>
            <div style={{display: "flex"}}>
                <EditIcon style={{cursor: "pointer"}} onClick={() => setEditingOpened(true)} />
                <CloseIcon style={{cursor: "pointer", marginLeft: 10}} onClick={() => dispatch(deleteAction(index))} />
            </div>
        </div>
    );
}

export default ActionRow;